<template>
	<ActivityLayout class="kr-owner-activity">
		<template #badge>
			<AssignmentChangeActivityBadge />
		</template>
		<template #text>
			<p v-html="translate( `text`, {
				changedBy: activity.changedBy,
				from: activity.from,
				to: activity.to
			} )"></p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import AssignmentChangeActivityBadge from "../Activity/AssignmentChangeActivityBadge.vue";

export default {
	name: "KROwnerActivity",
	components: {
		ActivityLayout,
		AssignmentChangeActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, from:String, to:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.KROwnerActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
